import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import News from './components/News';
import Contact from './components/Contact';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <News />
      <Contact />
      <Footer />
    </div>
  );
}
